import { createCacheParam, isCacheHit, ReduxCachedState } from 'common/utils/reduxCache'
import { fetchTemplate, fetchTemplateInstances } from 'common/services/template'
import { Template } from 'common/types/entities/mongo/template'
import { StateKey } from 'common/utils/flipState'

export interface TemplateState extends ReduxCachedState {
  template: Template
  templateData?: Template[]
}

export const initialState: TemplateState = {
  template: null,
  templateData: null,
}

const FETCH = '/template/FETCH'
const FETCH_INSTANCES = '/template/FETCH_INSTANCES'

export const getTemplate = (curState: StateKey, id: string) => {
  return async (dispatch, getState) => {
    const cacheParam = createCacheParam(FETCH, 'getTemplate', { curState, id })
    if (isCacheHit(getState().template[curState], cacheParam)) {
      return
    }

    const template = await fetchTemplate(id)

    const result: TemplateState = {
      template,
    }

    dispatch({
      curState,
      result,
      type: FETCH,
    })
  }
}

export const getTemplateData = (curState: StateKey, id: string) => {
  return async (dispatch, getState) => {
    const cacheParam = createCacheParam(FETCH_INSTANCES, 'getTemplateData', { curState, id })
    if (isCacheHit(getState().template[curState], cacheParam)) {
      return
    }

    const templateData = await fetchTemplateInstances(id, {})

    dispatch({
      curState,
      templateData,
      type: FETCH_INSTANCES,
    })
  }
}

const templateReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return action.result
    case FETCH_INSTANCES:
      return {
        ...state,
        templateData: action.templateData,
      }
    default:
      return state
  }
}

export default templateReducer
